
export enum STORAGE_KEYS {
    CART_STORAGE_KEY = "innerbalance-cart",
    COUPON = "coupon",
    DOC_LOCATION = "docLocation",
    USER_ID = "userId",
    QUIZ_COMPLETED = "quizCompleted",
    QUIZ_COMPLETED_ID = "quizCompletedId",
    QUIZ_DATA = "quizData",
    QUIZ_SYMPTOMS = "quizSymptoms",
    CHECKOUT_VISIT_URL = "checkoutVisitUrl",

    KLAVIYO_FORM_IDS = "klaviyoFormIds",
    IS_ADMIN_LOGIN = "isAdminLogin",
    ID_CARD_VERIFIED_AT_STORAGE_KEY = "idCardVerifiedAt",
    RECENT_ORDERS = "ib-recent-orders",
    PENDING_PURCHASES = "ib-pending-purchases",
    INTERESTED_PRODUCT = "interestedProduct",
    CHECKOUT_ATTEMPT_ID = "checkoutAttemptId",
    CHECKOUT_SUBMIT_AT = "checkoutSubmitAt",

    MARKETING_CONSENT = "marketingConsent",
    /** Quiz → Plan Ready PQP contract: capture_intent and optional contact (JSON). */
    OESTRA_PQP_CAPTURE = "oestraPqpCapture",

    BODYMATCHED_FINASTERIDE = "bodymatchedFinasteride",
}